export const fields = {
  leadTypeName: {
    label: "Lead Type",
    type: "text",
    rules: "required|string",
  },
};
